import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FavoriteService } from 'src/app/_shared/service/favorite.service';
import { SharedModule } from '../_shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { AlertsModule } from '../shared/modules/alerts/alerts.module';
import { CreateWatchListSheetComponent } from './component/create-watch-list-sheet/create-watch-list-sheet.component';
import { FollowedPropertiesComponent } from './component/followed-properties/followed-properties.component';
import { FollowedPropertiesGroupCardComponent } from './followed-properties-group-card/followed-properties-group-card.component';
import { FollowedPropertiesRoutingModule } from './followed-properties-routing.module';

@NgModule({
  declarations: [FollowedPropertiesGroupCardComponent, FollowedPropertiesComponent, CreateWatchListSheetComponent],
  imports: [
    AlertsModule,
    CommonModule,
    FollowedPropertiesRoutingModule,
    FormsModule,
    MatBadgeModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    NavigationModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [FollowedPropertiesComponent, CreateWatchListSheetComponent],
  entryComponents: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FollowedPropertiesModule {
  constructor(private favoriteService: FavoriteService) { }
}
